import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { useStoryblokApi } from '@storyblok/vue';

export const useKnowledgeStore = defineStore('knowledge', () => {
    const articleCategories = ref([]);
    const articles = ref([]);
    const categoryFilter = ref(null);
    const pageNumber = ref(1);
    const numberOfPages = ref(0);
    const numberOfArticles = ref(0);
    const articlesPerPage = 9;

    const storyblokApi = useStoryblokApi();

    async function fetchCategories() {
        const { data: datasourceData } = await storyblokApi.get('cdn/datasource_entries', {
            datasource: 'article-categories',
        });
        articleCategories.value = datasourceData.datasource_entries;
    }

    async function fetchArticles(page = 1, category = null) {
        pageNumber.value = page;
        let filterQuery = category ? { category: { like: category } } : {};
        
        const { data, headers } = await storyblokApi.get('cdn/stories', {
            starts_with: 'knowledge',
            page: page,
            per_page: articlesPerPage,
            filter_query: filterQuery,
        });
        
        articles.value = data.stories;
        numberOfArticles.value = headers.total;
        numberOfPages.value = Math.ceil(headers.total / articlesPerPage);
    }

    async function categorySelected(category) {
        categoryFilter.value = category;
        await fetchArticles(1, category);
    }

    function setCategory(category) {
        categoryFilter.value = category;
    }

    function showPreviousButton() {
        return pageNumber.value > 1;
    }

    function showNextButton() {
        return pageNumber.value < numberOfPages.value;
    }

    // Computed property for the 'from' value
    const from = computed(() => {
        return pageNumber.value * articlesPerPage - articlesPerPage + 1;
    });

    // Computed property for the 'to' value
    const to = computed(() => {
        const maxIndex = pageNumber.value * articlesPerPage;
        return Math.min(maxIndex, numberOfArticles.value);
    });

    function isActive(category) {
        return categoryFilter.value === category.value;
    }

    return {
        articleCategories,
        articles,
        fetchCategories,
        fetchArticles,
        categorySelected,
        setCategory,
        numberOfArticles,
        numberOfPages,
        pageNumber,
        showPreviousButton,
        showNextButton,
        from,
        to,
        categoryFilter,
        isActive,
    };
});
